import { IReportHistoryOptions } from "../types/reportsInterfaces";

export const getVisibleHistory = (historyArray: IReportHistoryOptions[], currentPage: number, itemsPerPage: number) =>
  historyArray?.slice((currentPage - 1) * itemsPerPage, (currentPage - 1) * itemsPerPage + itemsPerPage);
